import React, { useState, useEffect } from "react";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
// import "react-pdf/dist/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;

function PDF(props) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    console.log("on document load success");
    setNumPages(numPages);
  };

  const clicked = ({ pageNumber }) => {
    console.log(pageNumber);
  };

  return (
    <div className="pdf-container">
      {/* <Document
        file={props.url}
        onLoadSuccess={onDocumentLoadSuccess}
        onItemClick={clicked}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <div className="pdf-page-container" key={`pdfpage${index + 1}`}>
            <Page
              className="pdf-page"
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              renderTextLayer={false}
            
            />
            
          </div>
        ))}
      </Document> */}

      <iframe
        src={props.url}
        title="PDF Viewer"
        width="100%"
        height="600"
        frameBorder="0"
      ></iframe>
    </div>
  );
}

export default PDF;
